import React from 'react';
import './SectionHint.css';

/**
 * SectionHint — une phrase courte « à quoi ça sert + ce que tu y gagnes », posée
 * sous le titre d'un encart. Objectif : qu'un utilisateur qui débarque comprenne
 * la valeur en 2 secondes, sans deviner. Discret, épuré, non dismissible (c'est
 * de l'explication permanente, pas un tip d'onboarding).
 *
 * <SectionHint>Appee te prévient tout seul quand un truc mérite ton attention.</SectionHint>
 * Variante fondée sur du violet clair : tone="light" (sur fond blanc).
 */
export default function SectionHint({ children, tone = 'default' }) {
  return (
    <p className={`section-hint section-hint-${tone}`}>
      <span className="section-hint-ic" aria-hidden="true">💡</span>
      <span>{children}</span>
    </p>
  );
}
